<app-modal [id]="modalId" [maskClose]="false">
  <aside class="modal cart-modal">
    <div [@slideInOut]="visible ? 'open' : 'closed'" class="modal-body">
      <div class="header">
        <div class="cart-logo">
          <img [src]="'/assets/img/defaults/shopping-cart-black.png'" >
          <p class="title">Cart</p>
        </div>
        <div class="button regular close" (click)="close()"><img src="../../../assets/img/defaults/chevron-up.png" /></div>
      </div>
      @if (loading) {
        <app-spinner></app-spinner>
      }
      @if (order && order.items && order.items.length && !loading) {
        <div>
          @for (item of order.items; track item) {
            <div class="content">
              @if (item.itemType === 'event') {
                <app-cart-event-nugget [item]="item"></app-cart-event-nugget>
              }
              @if (item.itemType === 'subscription') {
                <app-cart-subscription-nugget [item]="item"></app-cart-subscription-nugget>
              }
              @if (item.itemType === 'featuredBook') {
                <app-cart-feature-nugget [item]="item"></app-cart-feature-nugget>
              }
              @if (item.itemType === 'promoStack') {
                <app-cart-promo-stack-nugget [item]="item"></app-cart-promo-stack-nugget>
              }
            </div>
          }
          <div class="footer">
            <div class="totals">
              <p class="total-amount">
                Total
                @if (order && order.items && order.items.length && !loading) {
                  <span class="quantity">
                    @if (order) {
                      <span>({{order.items.length}} items)</span>
                    }
                  </span>
                }
              </p>
              <p class="total-amount">${{orderTotalAmount.toFixed(2)}}</p>
            </div>
            <button class="regular button solid-green checkout-now" (click)="checkout()">Checkout Now</button>
            <a class="continue-shopping" (click)="continueShopping()">Continue Shopping</a>
          </div>
        </div>
      }
      @if (!order || !order.items || !order.items.length) {
        <div>
          <p class="empty" >Your cart is empty!</p>
        </div>
      }
    </div>
    <div class="cart-modal-background" (click)="close()"></div>
  </aside>
</app-modal>
